import { toast } from 'react-toastify'

export const showToast = (message: string, type = 'success') => {
  if (type === 'success') {
    toast.success(message)
  } else {
    toast.error(message)
  }
}
